import React from 'react';

import {useTranslation} from 'react-i18next';

import {PermissionAccess} from 'components/common/PermissionAccess';
import {NavBar, NavLink} from 'components/ui-kit/NavBar';
import {ROUTE} from 'core/routes';

import {UserPermission} from 'types';

export const GridsNavigation = () => {
    const EXTRA_ACTIVE_PATH_FOR_DOCUMENTS = {
        [ROUTE.DOCUMENTS_INVOICES_INCOMING]: true,
        [ROUTE.DOCUMENTS_INVOICES_OUTGOING]: true,
    };
    const {t} = useTranslation();
    return (
        <NavBar>
            <NavLink exact to={ROUTE.DOCUMENTS_DOCUMENTS}>
                {t('pages.documents.documents.gridName')}
            </NavLink>
            <NavLink
                isActive={(_match: any, location) =>
                    location.pathname in EXTRA_ACTIVE_PATH_FOR_DOCUMENTS
                }
                exact
                to={ROUTE.DOCUMENTS_INVOICES}
            >
                {t('pages.documents.invoices.gridName')}
            </NavLink>
            <NavLink
                isActive={(_match: any, location) => location.pathname === ROUTE.DOCUMENTS_MOVING}
                exact
                to={ROUTE.DOCUMENTS_MOVING}
            >
                {t('pages.documents.moving.gridName')}
            </NavLink>
            <PermissionAccess permissions={[UserPermission.DOCUMENT_VIEW_DROPOUT]}>
                <NavLink exact to={ROUTE.DOCUMENTS_WITHDRAWAL}>
                    {t('pages.documents.withdrawal.gridName')}
                </NavLink>
            </PermissionAccess>
            <PermissionAccess permissions={[UserPermission.DOCUMENTS_DECLARATION_LIST]}>
                <NavLink exact to={ROUTE.DOCUMENTS_GDS}>
                    {t('pages.documents.gds.gridName')}
                </NavLink>
            </PermissionAccess>
            <PermissionAccess
                permissions={[
                    UserPermission.RECEIPT_GRID_VIEW,
                    UserPermission.ALL_PRODUCT_GRID_VIEW,
                ]}
            >
                <NavLink exact to={ROUTE.DOCUMENTS_CHECKS}>
                    {t('pages.documents.checks.gridName')}
                </NavLink>
            </PermissionAccess>
        </NavBar>
    );
};
